module.exports = __webpack_public_path__ + "static/media/searchIcon.2d7ca206.svg";